import * as React from 'react';

export function SuperAdminDashboard() {
  return (
    <div className="container-fluid mt-4">
      <h1>Superadmin console</h1>
      <p className="text-muted">Migration shell is ready. Next step: move Schools into this area.</p>
    </div>
  );
}
